import { SERVICES } from '@/data/services';

export const PRODUCT_OPTIONS = [
  ...SERVICES.map((s) => ({ id: s.id, label: s.title })),
  { id: 'ostalo', label: 'Nešto drugo / nisam siguran' },
];

export const ARTWORK_OPTIONS = [
  { id: 'gotov', label: 'Imam gotov dizajn za štampu' },
  { id: 'logo', label: 'Imam samo logo / ideju' },
  { id: 'nemam', label: 'Nemam, treba mi dizajn' },
];

export const URGENCY_OPTIONS = [
  { id: 'hitno', label: 'Hitno (1–2 dana)' },
  { id: 'sedmica', label: 'Do sedmicu dana' },
  { id: 'nehitno', label: 'Nije hitno' },
];

const labelOf = (options, id) => options.find((o) => o.id === id)?.label;

export const isQuoteComplete = (f) => Boolean(f.product && f.details.trim());

// Sastavlja pregledan tekst poruke za WhatsApp; prazna polja se izostavljaju.
export function buildQuoteMessage(f) {
  const lines = ['Poštovani, šaljem upit za ponudu preko web stranice.', ''];
  const add = (label, value) => value && lines.push(`*${label}:* ${value}`);

  add('Proizvod / usluga', labelOf(PRODUCT_OPTIONS, f.product));
  add('Opis', f.details.trim());
  add('Količina', f.quantity.trim());
  add('Dimenzije', f.size.trim());
  add('Priprema / dizajn', labelOf(ARTWORK_OPTIONS, f.artwork));
  add('Rok', labelOf(URGENCY_OPTIONS, f.urgency));
  add('Ime / firma', f.name.trim());
  add('Email', f.email.trim());

  lines.push('', 'Hvala unaprijed!');
  return lines.join('\n');
}
